import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-brand-cream pt-12 pb-16 px-4 text-center overflow-hidden" data-id="element-99">
      <div className="max-w-4xl mx-auto" data-id="element-100">
        <motion.h1 className="text-4xl md:text-6xl font-black text-brand-darkGreen mb-8 leading-tight" initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-101">
          Dejá de pensar todos los días qué mandar en la vianda
        </motion.h1>

        <motion.a href="https://comerfacil.shop/cart/44790229336179:1" className="block mb-8 relative" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} whileHover={{
        scale: 1.02
      }} data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/haLLjmxdRpmCRipa68E4K6/ChatGPT_Image_17_abr_2026,_13_28_28.png" alt="Comidas que suman para chicos Ebook" className="w-full max-w-[500px] mx-auto rounded-2xl shadow-2xl" data-id="element-103" />
        </motion.a>

        <motion.h2 className="text-2xl md:text-3xl font-bold text-brand-green mb-8" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-104">
          Recetas fáciles + organización simple para resolver la semana sin
          estrés
        </motion.h2>

        <motion.div className="flex flex-col gap-4 text-lg md:text-xl font-medium text-brand-darkGreen mb-10 text-left max-w-2xl mx-auto bg-white p-6 rounded-xl shadow-sm border border-brand-beige" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-105">
          <p className="flex items-start gap-3" data-id="element-106">
            <span className="text-2xl" data-id="element-107">👉</span>
            <span data-id="element-108">
              Con frutas y verduras escondidas que los chicos{' '}
              <strong data-id="element-109">sí comen</strong>
            </span>
          </p>
          <p className="flex items-start gap-3" data-id="element-110">
            <span className="text-2xl" data-id="element-111">👉</span>
            <span data-id="element-112">
              Ideas reales, rápidas y caseras para{' '}
              <strong data-id="element-113">todos los días</strong>
            </span>
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-114">
          <Button data-id="element-115">QUIERO RESOLVER MIS VIANDAS</Button>
        </motion.div>
      </div>
    </section>;
}